// extracted by mini-css-extract-plugin
module.exports = {"icon_img":"footer_icon_img__ZRfRP"};